import { render, staticRenderFns } from "./BestPractices.vue?vue&type=template&id=ac0355e2&scoped=true&"
import script from "./BestPractices.vue?vue&type=script&lang=ts&"
export * from "./BestPractices.vue?vue&type=script&lang=ts&"
import style0 from "./BestPractices.vue?vue&type=style&index=0&id=ac0355e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0355e2",
  null
  
)

export default component.exports